import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezonePlugin);
dayjs.extend(isBetweenPlugin);
dayjs.extend(customParseFormat);
export class DateUtil {
    static getDateAsString(date, timezoneId = 'Asia/Tokyo') {
        return dayjs(date).tz(timezoneId).format('YYYY-MM-DD');
    }
    static convertUtcTimezone(date, timezoneId = 'Asia/Tokyo') {
        return dayjs.utc(date).tz(timezoneId).toDate();
    }
    static parse(stringOrDate) {
        const _dayjs = dayjs(stringOrDate);
        if (_dayjs?.isValid())
            return _dayjs.toDate();
        return undefined;
    }
    static getTimestampAsString(
    /**
     * Value should be millis or ISO Date String
     */
    value, timezoneId, locale) {
        const date = DateUtil.parse(value);
        if (!date)
            return '';
        const zonedDate = DateUtil.convertUtcTimezone(date, timezoneId);
        return zonedDate.toISOString();
    }
    static isValid(validatedDate, format) {
        if (!validatedDate)
            return false;
        if (typeof validatedDate === 'string' &&
            (validatedDate.trim() === '' || validatedDate.length < 5))
            return false;
        return dayjs(validatedDate, format, true).isValid();
    }
    static isActive(startDate, endDate) {
        const start = startDate ? dayjs(startDate) : dayjs(new Date(0));
        const end = endDate ? dayjs(endDate) : dayjs(new Date(8640000000000000));
        return dayjs().isBetween(start, end);
    }
    static isExpired(expiryDate) {
        return dayjs().isAfter(expiryDate);
    }
    static currentDateUTC() {
        return dayjs().utc().format('YYYY-MM-DD HH:mm:ss');
    }
    static currentDateTime() {
        return dayjs().format('YYYY-MM-DD HH:mm:ss');
    }
    static expiredAt45s() {
        return dayjs().tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss');
    }
    static format(date, pattern = 'YYYY-MM-DD HH:mm:ss') {
        return dayjs(date).format(pattern);
    }
    static formatApiDate(apiDateString, pattern = 'YYYY-MM-DD HH:mm:ss') {
        const isValidFormat = dayjs(apiDateString, DateUtil.API_DATETIME_FORMAT, true).isValid();
        return isValidFormat
            ? dayjs(apiDateString, DateUtil.API_DATETIME_FORMAT).tz('Asia/Tokyo').format(pattern)
            : DateUtil.format(apiDateString, pattern);
    }
    static formatUTC(date, timezoneId, pattern) {
        return dayjs
            .utc(date)
            .tz(timezoneId || 'Asia/Tokyo')
            .format(pattern || 'YYYY-MM-DD HH:mm:ss');
    }
    static toUnixTimestamp(date) {
        if (date instanceof Date) {
            return (date.getTime() / 1000).toFixed(0);
        }
        return undefined;
    }
}
DateUtil.API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
